import { render, staticRenderFns } from "./AuthorBlock.vue?vue&type=template&id=7184ef06"
import script from "./AuthorBlock.vue?vue&type=script&lang=js"
export * from "./AuthorBlock.vue?vue&type=script&lang=js"
import style0 from "./AuthorBlock.vue?vue&type=style&index=0&id=7184ef06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports